/*
 * 1DS JS SDK ID Sync plugin, 3.2.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
import { __extendsFn as __extends } from "@microsoft/applicationinsights-shims";
/**
* WebAnalyticsPlugin.ts
* @author Ram Thiru (ramthi) and Hector Hernandez (hectorh)
* @copyright Microsoft 2018
* File containing the interfaces for WebAnalytics SDK.
*/
import dynamicProto from "@microsoft/dynamicproto-js";
import Ix from "./Ix";
import { BaseTelemetryPlugin } from "@microsoft/1ds-core-js";
var IdSyncPlugin = /** @class */ (function (_super) {
    __extends(IdSyncPlugin, _super);
    function IdSyncPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "IdSyncPlugin";
        _this.version = '3.2.4';
        var _ix;
        dynamicProto(IdSyncPlugin, _this, function (_self, _base) {
            _self.initialize = function (coreConfig, core, extensions) {
                // Make sure we have a config definition for this identifier
                var identifier = _this.identifier;
                var extConfig = coreConfig.extensionConfig[identifier] || {};
                coreConfig.extensionConfig[identifier] = extConfig;
                // Check in channels
                var postChannel = core.getPlugin("PostChannel");
                if (postChannel) {
                    _ix = new Ix(extConfig, core);
                    postChannel.plugin.addResponseHandler(function (response) { _ix.idSync(response); });
                }
            };
            _self.processTelemetry = function (evt, itemCtx) {
                _self.processNext(evt, itemCtx);
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _ix = null;
            };
        });
        return _this;
    }
// Removed Stub for IdSyncPlugin.prototype.initialize.
// Removed Stub for IdSyncPlugin.prototype.processTelemetry.
    // This is a workaround for an IE8 bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    // this will be removed when ES3 support is dropped.
    IdSyncPlugin.__ieDyn=1;

    return IdSyncPlugin;
}(BaseTelemetryPlugin));
export { IdSyncPlugin };
//# sourceMappingURL=IdSyncPlugin.js.map